/**
 * 这里定义所有页面组件 以及他们的key
 */
const pages = {

    "school_menu_home": { //校区功能管理
        view: () => import("../views/Home"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_staff_manage": { //员工管理
        view: () => import("../views/teaching/staff/StaffList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_class_manage": { //班级管理
        view: () => import("../views/teaching/clazz/ClassList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_manage": { //学生管理
        view: () => import("../views/teaching/student/StudentList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_work_manage": { //作品管理
        view: () => import("../views/teaching/works/WorkList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_work_statistics": { //学生作品统计
        view: () => import("../views/teaching/works/WorkStaistics"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_taskwork_manage": { //作业管理
        view: () => import("../views/teaching/works/TaskWorkList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_learn_manage": { //学习情况
        view: () => import("../views/teaching/learn/LearnList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_learn_task_manage": { //任务统计
        view: () => import("../views/teaching/learn/LearnTaskList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_lessonsystem_manage": { //总部课程体系
        view: () => import("../views/lesson/LessonSystemList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_schoollessonsystem_manage": { //本校课程体系
        view: () => import("../views/lesson/school/SchoolLessonSystemList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_user_manage": { //用户管理
        view: () => import("../views/running/user/UserList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_subinstitution_manage": { //我的机构管理
        view: () => import("../views/institution/SubInstitutionList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_institution_charge_manage": { //开通收费账号
        view: () => import("../views/institution/charge/SchoolCharge"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_institution_charge_manage_log": { //机构收费记录
        view: () => import("../views/institution/charge/SchoolChargeLog"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_institution_student_charge_manage_log": { //学生收费记录
        view: () => import("../views/institution/charge/SchoolStudentChargeLog"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_roleauth_manage": { //权限设置
        view: () => import("../views/auth/RoleManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_baseinfo_set": { //系统设置-机构信息
        view: () => import("../views/institution/EditBaseInfo"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_usage_record": { //系统设置-使用记录
        view: () => import("../views/institution/UsageRecordManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_programsite_infoset": { //编程平台设置 - 编程首页设置
        view: () => import("../views/program/EditSiteInfo"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_programsite_bannerset": { //编程平台设置 - 轮播图
        view: () => import("../views/program/EditBannerPage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_scratch_set": { //编程平台设置- Scratch
        view: () => import("../views/program/EditScratchPage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_officalsite_infoset": { //官网设置 - 官网信息
        view: () => import("../views/website/EditSiteInfo"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_officalsite_pageset": { //官网设置 - 页面设置
        view: () => import("../views/website/PageList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },

    "school_menu_teacher_class_manage": { //教师办公 - 班级管理
        view: () => import("../views/teacher/clazz/ClassList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },

    "school_menu_teacher_student_manage": { //教师办公 - 学生管理
        view: () => import("../views/teaching/student/StudentList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
        attr: {isSelf: true}
    },

    "school_menu_teacher_lesson_manage": { //教师办公 - 排课管理
        view: () => import("../views/teacher/lessonarrange/LessonArrangeManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },

    "school_menu_student_work_manage": { //教师办公 - 学生作业
        view: () => import("../views/teaching/works/TaskWorkList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
        attr: {isSelf: true}
    },

    "school_menu_doteach_manage": { //教师办公 - 上课管理
        view: () => import("../views/officework/class/ClassDetail"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
        attr: {
            isSelf: true
        }
    },

    "school_menu_teacher_lessonresource": { //教师办公 - 课程资源
        view: () => import("../views/teacher/lessonsystem/LessonSystemList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },


    "school_menu_exam_test": { //题库考试管理 - 考试管理
        view: () => import("../views/examtest/list"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_exam_result": { //题库考试管理 - 考试结果
        view: () => import("../views/examtest/examResultList"),
    },
    "school_menu_exam_update_state": { //题库考试管理 - 考试状态更改
        view: () => import("../views/examtest/updateExamState"),
    },

    "school_menu_basic_data": { //基础数据管理
        view: () => import("../views/website/BasicDataList"),
    },
    "school_menu_officalsite_article_type": { //网址新闻分类
        view: () => import("../views/website/ArticleTypeList"),
    },
    "school_menu_officalsite_article": { //网址新闻
        view: () => import("../views/website/ArticleList"),
    },
    "school_menu_minecoin": {
        view: () => import('../views/coin/Mine')
    },
    "school_menu_material_manage": { //素材管理
        view: () => import("../views/material/MaterialManage"),
    },
    "school_menu_train_category": { //训练分类管理
        view: () => import("../views/train/TrainCategoryList"),
    },
    "school_menu_train_tag": { //训练标签管理
        view: () => import("../views/train/TrainTagList"),
    },
    "school_menu_train_question": { //训练题目管理
        view: () => import("../views/train/TrainQuestionList"),
    },
    "school_menu_train_module_manage": { //训练模块管理
        view: () => import("../views/train/TrainModuleList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_train_config": { //训练模块管理
        view: () => import("../views/train/config/TrainConfigList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_train_total_score_statistics": { //训练得分统计
        view: () => import("../views/train/statistics/TotalScore"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_train_avgscore_crrectrate_statistics": { //训练题目分析
        view: () => import("../views/train/statistics/QuestionStatistics"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_train_opertion_work": { //训练操作题
        view: () => import("../views/train/statistics/QuestionOperation"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_defaul_train_total_score_statistics": { //自由训练得分统计
        view: () => import("../views/train/statistics/defaul/TotalScore"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_my_prepare_lessons_manage": { //我的备课
        //view: () => import("../views/lesson/prepare/LessonSystemList"), //不要课程体系 只要课程 已经写得文件保留 以后可能扩展到课程体系
        view: () => import("../views/lesson/prepare/LessonPrepareManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_prepare_lessons_sharing_manage": { //备课共享
        //view: () => import("../views/lesson/prepare/LessonSystemSharingList"), //不要课程体系 只要课程 已经写得文件保留 以后可能扩展到课程体系
        view: () => import("../views/lesson/prepare/LessonManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_invite_student_manage": { //邀约试听
        view: () => import("../views/teaching/invitestudent/InviteStudentList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_my_code_base_manage": { //我的代码库
        view: () => import("../views/codeBase/CodeBaseManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_code_base_sharing_manage": { //代码库共享
        view: () => import("../views/codeBase/CodeBaseSharingManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_lessontask_manage": { //任务库管理
        view: () => import("../views/lesson/task/TaskManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_system_score_rule": { //系统积分规则
        view: () => import("../views/institution/SyetemScoreRule"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_platform_code_base_sharing_manage": { //平台代码库共享
        view: () => import("../views/codeBase/PlatformCodeBaseSharingManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_memu_subject_manage": { //主题管理
        view: () => import("../views/subject/SubjectManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_teaching_material_manage": { //教材管理
        view: () => import("../views/lesson/teachingMaterial/TeachingMaterialManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_talent_statistics": { //学生天赋统计
        view: () => import("../views/teaching/statistics/StudentTalentStaistics"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_interest_statistics": { //学生兴趣统计
        view: () => import("../views/teaching/statistics/StudentInterestStaistics"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_assess_statistics": { //能力评估图谱
        view: () => import("../views/echart/Statistics"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_student_skill_point_statistics": { //学生能力统计
        view: () => import("../views/teaching/statistics/StudentSkillPointStaistics"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_card_coupon": { //卡劵
        view: () => import("../views/institution/cardCoupon/CardCouponManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_memu_activity_manage": { //活动
        view: () => import("../views/institution/activity/ActivityManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_memu_program_tab_manage": { //编程首页标签配置
        view: () => import("../views/program/ProgramTabList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_memu_program_teacher_info":{//教师信息
        view: () => import("../views/program/ArticleList.vue"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_memu_posts_manage": { //发帖
        view: () => import("../views/posts/PostsManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_memu_posts_staff_manage": { //发帖
        view: () => import("../views/posts/StaffList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_goods_manage": {//商品
        view: () => import("../views/goods/GoodsManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_self_apply_manage": {//商品我的申请
        view: () => import("../views/goods/SelfApplyManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_innovare_score_manage": {//创新币记录
        view: () => import("../views/goods/InnovareScoreManage"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },
    "school_menu_challenge_round_module": {//挑战赛
        view: () => import("../views/challenge/ChallengeList"),
        isFuncPage: true, //是功能菜单页面，和权限挂钩
    },


    //下面的都是内页，跟权限没关系
    "school_page_train_choose_question_manage": { //选择题目
        view: () => import("../views/train/ChooseQuestionDrawer"),
    },
    "school_page_train_choose_lesson_task_manage": { //选择任务
        view: () => import("../views/train/ChooseLessonTaskDrawer"),
    },
    "school_page_train_question_manage": { //训练题目
        view: () => import("../views/train/QuestionDrawer"),
    },
    "school_page_train__task_manage": { //训练任务
        view: () => import("../views/train/TaskDrawer"),
    },
    "school_page_exam_student_manage": { //考试考生管理
        view: () => import("../views/examtest/student/examStudentList"),
    },
    "school_page_exam_teacher_manage": { //考试阅卷老师管理
        view: () => import("../views/examtest/teacher/examTeacherList"),
    },

    "school_menu_question": { //题库考试管理 - 题库管理
        view: () => import("../views/questionBank/questionList"),
    },
    "school_menu_guide": { //使用指导
        view: () => import("../views/institution/HelpGuide"),
    },
    "school_page_class_student_manage": { //班级学生管理
        view: () => import("../views/teaching/student/ClassStudentList"),
    },
    "school_page_lesson_manage": { //总部课程体系,具体课程
        view: () => import("../views/lesson/LessonManage"),
    },
    "school_page_schoollesson_manage": { //总部课程体系,具体课程
        view: () => import("../views/lesson/school/SchoolLessonManage"),
    },

    "school_page_class_detail": { //班级上课
        view: () => import("../views/officework/class/ClassDetail"),
    },
    "school_page_subinstitution_edit": { //子机构编辑
        view: () => import("../views/institution/SubInstitutionEdit"),
    },
    "school_page_website_module_set": { //网站模块设置
        view: () => import("../views/website/PageModuleSet"),
    },
    "school_page_lessonsytem_detail": { //课程体系详情
        view: () => import("../views/lesson/LessonSystemDetail"),
    },
    "school_page_read_only_lesson_manage": { //课程管理 只能查看 不能操作
        view: () => import("../views/lesson/prepare/LessonManage"),
    },
    "school_page_prepare_lessons_sharing_manage": { //备课共享
        view: () => import("../views/lesson/prepare/LessonManage"),
    },
    "school_page_code_base_sharing_manage": { //代码库共享
        view: () => import("../views/codeBase/CodeBaseSharingManage"),
    },
    "school_page_platform_code_base_sharing_manage": { //平台代码库共享
        view: () => import("../views/codeBase/PlatformCodeBaseSharingManage"),
    },
    "school_page_exam_marking": { //阅卷
        view: () => import("../views/examtest/examMarking"),
    },
    "school_page_work_manage": { //作品管理
        view: () => import("../views/teaching/works/WorkList"),
    },
    "school_page_teaching_material_content_manage": { //教材内容管理
        view: () => import("../views/lesson/teachingMaterial/TeachingMaterialContentManage"),
    },
    "school_menu_agent_info": { //使用指导
        view: () => import("../views/institution/agentInfo/agentInfoManage"),
    },
    "school_page_train_avgscore_crrectrate_statistics": { //训练题目分析
        view: () => import("../views/train/statistics/QuestionStatistics"),
    },
    "school_page_train_opertion_work": { //训练操作题
        view: () => import("../views/train/statistics/QuestionOperation"),
    },
    "school_page_lesson_series": { //课程包
        view: () => import("../views/institution/lessonSeries/LessonSeriesManage"),
    },
    "school_page_lesson_platform_manage": { //课程管理
        view: () => import("../views/institution/lessonSeries/LessonManage"),
    },
    "school_page_activity_builtin_form_manage": { //活动内置表单
        view: () => import("../views/institution/activity/ActivityBuiltInForm"),
    },
    "school_page_activity_user_info_manage": { //活动用户信息
        view: () => import("../views/institution/activity/ActivityUserInfoManage"),
    },
    "school_page_posts_detail_manage": { //活动用户信息
        view: () => import("../views/posts/PostsDetailManage"),
    },
    "school_page_posts_prepare_lessons_sharing_manage": { //备课共享
        view: () => import("../views/posts/LessonManage"),
    },
    "school_page_posts_code_base_sharing_manage": { //代码库共享
        view: () => import("../views/posts/CodeBaseSharingManage"),
    },
    "school_menu_goods_detail_manage": {//商品详情
        view: () => import("../views/goods/GoodsDetailManage"),
    },
    // ---------- 考试相关 ----------
    //考试分析
    "school_page_exam_statistics": {
        view: () => import("../views/examtest/examStatistics"),
    },
    //考试分析
    "school_class_avg": {
        view: () => import("../views/examtest/classAvg.vue"),
    },
    // 参考统计
    "school_people_number_statistics": {
        view: () => import("../views/examtest/peopleNumberStatistics.vue"),
    },
    // 批阅统计
    "school_read_over_statistics": {
        view: () => import("../views/examtest/readOverStatistics.vue"),
    },
    // 班级批阅进度
    "school_class_read_over_schedule": {
        view: () => import("../views/examtest/classReadOverSchedule.vue"),
    },
    // 批量编辑分数
    "school_exam_batch_edit_score": {
        view: () => import("../views/examtest/batchEditScore.vue"),
    },
}

const PBL_pages = {
    "pbl_project_institution_mgr": {
        view: () => import("../views/pbl/project/institution/Mgr.vue"),
        isFuncPage: true,
    },
    "pbl_target_institution_mgr": {
        view: () => import("../views/pbl/target/institution/Mgr.vue"),
        isFuncPage: true,
    },
    "pbl_task_institution_mgr": {
        view: () => import("../views/pbl/task/institution/Mgr.vue"),
        isFuncPage: true,
    },
    "pbl_lesson_institution_mgr": {
        view: () => import("../views/pbl/lesson/institution/Mgr.vue"),
        isFuncPage: true,
    },
    "pbl_file_institution_mgr": {
        view: () => import("../views/pbl/file/institution/Mgr.vue"),
        isFuncPage: true,
    },
    "pbl_group_institution_mgr": {
        view: () => import("../views/pbl/group/institution/Mgr.vue"),
        isFuncPage: true,
    },
    "pbl_user_institution_mgr": {
        view: () => import("../views/pbl/member/institution/Mgr.vue"),
        isFuncPage: true,
    }
}

Object.assign(pages,PBL_pages);

export default function (key) {
    return pages[key];
}
